<template>
  <div id="bm-team-officer-edit" >
    <!-- 未登录/注册 之前展示为空 start -->
    <van-cell-group>
      <div class="bm-cell">
        <van-cell title="头像" :border="false">
          <template #value>
            <div class="teamIcon">
              <van-uploader class="uploader" :after-read="onRead">
                <img v-if="imgObj.avatarImg" :src="imgObj.avatarImg" alt="">
                <img v-if="!imgObj.avatarImg" src="@/assets/images/team-logo-empty.png">
              </van-uploader>
            </div>
          </template>
        </van-cell>
        <div class="note-label">白底免冠证件照(支持.jpg、.jpeg、.png、.bmp格式)</div>
      </div>
      <van-cell title="姓名" :value="officer.name" is-link @click="setValues('name')" />
      <van-cell title="手机号" :value="officer.mobile" is-link @click="setValues('mobile')" />
      <van-cell title="角色" :value="officer.role" is-link @click="isShowRole = true" />

    </van-cell-group>
    <div style="width: 100%; height: 100px;" ></div>

    <!-- submit -->
    <div class="foot" v-if="officer.id">
      <van-button type="primary" size="large" @click="saveOfficer" >确认</van-button>
      <!--      <div style="width: 100%; height: 20px;" ></div>-->
    </div>
    <div class="foot" v-else>
      <van-button type="primary" size="large" @click="saveOfficer" >确认</van-button>
    </div>

    <van-popup v-model="PopupShow" position="right" class="popup">
      <div style="width: 100%; height: 30px;" ></div>
      <van-row class="form" type="flex" justify="space-between" style="padding: 0 20px;">
        <van-col span="24" >
          <van-cell-group>
            <van-field v-model="newValue" placeholder="请输入..." />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24" style="padding: 0 30px;">
          <van-button round block type="primary" @click="confirmValue" style="margin-top: 15px;">确认</van-button>
          <van-button class="back-btn" round block @click="PopupShow=false" style="margin-top: 10px;">返回</van-button>
        </van-col>
      </van-row>
    </van-popup>

    <van-popup v-model="isShowRole" position="bottom" >
      <van-picker
              show-toolbar
              @cancel="isShowRole = false"
              @confirm="ConfirmRole"
              :columns="roleArray"
      />
    </van-popup>

  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { ImageFormat, varConfig } from '@/utils/'
import { getQiniuUploadToken } from '@/api/user'
import { getBMMatchTeamOfficerList, updateOfficer, addOfficer } from '@/api/team'
import { Cell, CellGroup, Button, Popup, Picker, Toast, Icon, Loading } from 'vant'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Picker).use(Toast).use(Icon).use(Loading)

export default {
  name: 'OfficerEdit',
  data () {
    return {
      query: '',
      PopupShow: false,
      teamName: '',
      teamId: null,
      matchId: null,
      isShowRole: false,
      qiniuToken: '',
      roleArray: ['领队', '队医', '教练'],
      imgObj: {
        avatarImg: ''
      },
      key: '',
      officerList: [],
      officer: {},
      officerId: '',
      newValue: ''
    }
  },
  computed: {
  },
  created() {
    this.query = this.$route.query
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    this.officerId = this.query.officerId

    this.getBMMatchTeamOfficerList()
    this.getQiniuToken()
  },
  mounted() {
    // this.imgObj.avatarImg = ImageFormat.squareImageView(this.player.avatar, 100)
  },
  methods: {
    setValues(key) {
      this.key = key
      this.newValue = this.officer[key]
      this.PopupShow = true
    },
    ConfirmRole(value) {
      this.officer.role = value
      this.isShowRole = false
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    },
    onRead(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.officer.avatar = res.hash
          this.imgObj.avatarImg = ImageFormat.squareImageView(res.hash, 100)
        }
      })
    },
    getBMMatchTeamOfficerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId,
        gameId: this.query.playerId
      }
      getBMMatchTeamOfficerList(params).then((response) => {
        let data = response.data
        this.officerList = data.officer
        this.officerList.filter(player => {
          if (Number(player.id) === Number(this.officerId)) {
            this.imgObj.avatarImg = ImageFormat.squareImageView(player.avatar, 100)
            this.officer = player
          }
        })
      })
    },
    confirmValue() {
      this.officer[this.key] = this.newValue
      this.PopupShow = false
    },
    saveOfficer() {
      const params = {
        avatar: this.officer.avatar,
        name: this.officer.name,
        mobile: this.officer.mobile,
        role: this.officer.role
      }

      if (this.officer.id) {
        params.officerId = this.officer.id
        updateOfficer(params).then((res) => {
          const data = res.data
          if (data) {
            Toast('更新成功')
            this.$router.go(-1)
          }
        })
      } else {
        params.matchId = this.matchId
        params.teamId = this.teamId
        addOfficer(params).then((res) => {
          const data = res.data
          if (data) {
            Toast('更新成功')
            this.$router.go(-1)
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus">
  #bm-team-officer-edit
    background-color: white
    width 100%
    .bm-cell
      .note-label
        white-space:pre-line;
        font-size: 12px;
        color: #969799;
        padding: 4px 0;
        border-bottom: 1px solid #f6f6f6;
        margin: 0 15px;
    .van-cell-group
      .van-cell:not(:last-child)::after
        right: 15px
      .van-cell:first-child
        .van-cell__title
          display flex
          align-content center
          align-items: center;
      .van-cell
        font-size:14px;
        font-weight:300;
        color:rgba(74,74,74,1);
        .van-icon::before
          color: #000000
        .desc-label
          position: absolute;
          bottom: 5px;
    .teamIcon
      width 50px
      height 50px
      background:rgba(230,230,230,1);
      border-radius:50px;
      float: right
      position relative
      img
        width 50px
        height: 50px;
        border-radius: 50%;
        background-color white
      .upload-profile-lod
        position absolute
        left: 0;
        top: 0;
        width 100%
        height: 100%
        background-color white
        .van-loading
          left: 50%
          top: 50%
          transform translate(-50%, -50%)
    .imgIcon
      border-radius 0;
      background-color: #f7f8fa;
      .van-uploader__upload-icon
        color: #dcdee0;
        font-size: 20px;
        position: relative;
        top: 15px;
        right: 15px;
      img
        border-radius 0;
    .foot
      bottom 0
      width 100%
      max-width: 480px
      padding-top 15px
      position fixed
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #32A377;
        line-height:25px;
      .van-button--primary
        background-color #FAFAFA
        font-size:20px;
        font-weight:400;
      .enroll
        height:55px;
        text-align center
        line-height 55px
        font-size:20px;
        color:rgba(255,255,255,1);
        background:rgba(50,163,119,1);
        border-radius:4px;
        width calc(100% - 80px)
        margin: 0 auto
        margin-bottom 30px
    .foot-create
      padding-top: 15px
      bottom 0
      width 100%
      max-width: 480px
      position fixed
      .van-button
        border none
        font-size:16px;
        font-weight normal
        color: #32A377;
        line-height:25px;
      .van-button--primary
        background-color #FAFAFA
        font-size:20px;
        font-weight:400;
    .popup
      width 100%
      height: 100%
      background-color white
      .van-button
        background-color #32a377
      .back-btn
        background-color #FFFFFF
      .form
        padding: 0 15px;
  .title
    padding: 15px
    h3
      font-size:30px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin 0
    p
      font-size:14px;
      font-weight:400;
      color:rgba(129,129,129,1);
      line-height:20px;
      margin 0
  .popup-code
    width 100%
    height: 100%;
    background-color: #32A377;
    background-image url('../../../../assets/images/bmb-bg.png')
    background-size 90%
  .code
    background-color white
    padding: 15px;
    width calc(100% - 70px )
    margin auto
    ox-shadow:0px 2px 15px 0px rgba(27,98,70,0.06);
    border-radius:15px;
    text-align center
    position absolute
    top: 45%
    left: 50%
    transform translate(-50%, -50%)
    .title
      font-size:28px;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      color:rgba(50,163,119,1);
    .title+img
      width 120px
      height: 120px
    p
      font-size:16px;
      font-weight:400;
      color:rgba(74,74,74,1);
      line-height:22px;
    .Advertising
      padding-top 10px
      width 100%
      height: 90px
    .off
      display none
      content: ""
      position absolute
      width: 50px
      height: 50px
      background:rgba(255,255,255,1);
      opacity:0.7979;
      bottom -70px
      border-radius 50%
      left 50%
      transform translate(-50%, 0)
      .van-icon
        text-align center
        line-height 50px
        font-size: 30px
        color #000000

  #bm-team-officer-edit .van-cell-group .van-cell .van-icon::before {
    color: #dcdee0;
  }

  #bm-team-officer-edit .van-uploader {
    position: relative;
    display: inline-block;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player/officer-edit.vue